import React, { useState, useEffect } from "react";

export type UserType =
  | "student"
  | "teacher"
  | "admin-startup"
  | "admin-school"
  | "inspecteur"
  | "parent";

interface ManualAccountCreationProps {
  onSend: (userType: UserType) => void;
  handleChange: (
    input: string,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  values: { [key: string]: any };
}

const ManualAccountCreation: React.FC<ManualAccountCreationProps> = ({
  onSend,
  handleChange,
  values,
}) => {
  const [userTypeValue, setUserTypeValue] = useState<UserType>(values.userType);

  useEffect(() => {
    onSend(userTypeValue);
  }, [userTypeValue]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Envoyer les données au parent
  };

  return (
    <form
      onSubmit={(e) => handleSubmit(e)}
      className="w-full max-w-md mx-auto p-4 md:p-8 bg-white rounded"
    >
      <div className="flex mb-4 items-center justify-center w-full">
        <label className="block mb-2 w-full text-black text-sm md:text-base font-normal font-['Open Sans']">
          TYPE UTILISATEUR
          <select
            className="p-2 border border-gray-300 rounded w-full mt-3 text-sm md:text-base"
            value={userTypeValue}
            onChange={(e) => setUserTypeValue(e.target.value as UserType)}
          >
            {/* <option value="" disabled>
              De quelle source provient votre exercice ?
            </option> */}
            <option value="student">Elève</option>
            <option value="teacher">Enseignant</option>
            <option value="admin-school">Administrateur école</option>
            <option value="admin-startup">Administrateur startup</option>
            <option value="inspecteur">CP/Inspecteur</option>
            <option value="parent">Parent</option>
          </select>
        </label>
      </div>
    </form>
  );
};

export default ManualAccountCreation;

interface RenderDivProps {
  title: string;
  value: string;
  isHidden: boolean;
}

export const RenderDiv: React.FC<RenderDivProps> = ({
  title,
  value,
  isHidden,
}) => {
  const displayValue = isHidden ? "*".repeat(value.length) : value;

  return (
    <div className="flex flex-col sm:flex-row w-full sm:w-150 justify-between items-start sm:items-center gap-2 sm:gap-0">
      <div className="text-neutral-800 text-sm md:text-base font-semibold font-['Open Sans']">
        {title.toUpperCase()}
      </div>
      <div className="text-neutral-800 text-sm md:text-base font-normal font-['Open Sans'] break-words">
        {displayValue}
      </div>
    </div>
  );
};
